'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { ComponentProps, FC, MouseEventHandler, forwardRef } from 'react';

type Props = ComponentProps<typeof Link>;

export const NextLink: FC<Props> = forwardRef<HTMLAnchorElement, Props>(
  ({ children, prefetch, onMouseEnter, ...props }, ref) => {
    const router = useRouter();

    const onHover: MouseEventHandler<HTMLAnchorElement> = (event) => {
      if (prefetch !== false) {
        const href = props.href.toString();
        router.prefetch(href);
      }
      if (onMouseEnter) {
        onMouseEnter(event);
      }
    };

    return (
      <Link {...props} onMouseEnter={onHover} prefetch={false} ref={ref}>
        {children}
      </Link>
    );
  },
);

NextLink.displayName = 'NextLink';
